import React, { useEffect, useState } from "react";

import { Redo, Close } from "icons";

import AirbyteApi from "apis/airbyte";
import { Button, PageLoader } from "clearsense-ui/components";

const Sync = ({ connectionId, isSyncing }) => {
  const [jobId, setJobId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchJobs = async () => {
    const payload = {
      configId: connectionId,
      configTypes: ["sync"],
    };
    try {
      setIsLoading(true);
      const {
        data: { jobs },
      } = await AirbyteApi.fetchJobs(payload);
      findActiveJob(jobs);
    } catch (error) {
      logger.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const findActiveJob = jobs => {
    const runningJob = jobs.find(({ job }) => job.status === "running");
    if (runningJob) setJobId(runningJob.job.id);
  };

  const handleSync = async connectionId => {
    try {
      setIsLoading(true);
      const {
        data: { job },
      } = await AirbyteApi.syncConnection({ connectionId });
      setJobId(job?.id);
    } catch (error) {
      logger.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = async () => {
    try {
      setIsLoading(true);
      await AirbyteApi.cancelJob({ id: jobId });
      setJobId(null);
    } catch (error) {
      logger.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isSyncing) fetchJobs();
    else setJobId();
  }, [isSyncing]);

  if (isLoading) return <PageLoader />;

  return jobId ? (
    <Button
      style="text"
      icon={Close}
      label="Cancel sync"
      iconPosition="left"
      onClick={e => {
        e.stopPropagation();
        handleCancel();
      }}
      loading={isLoading}
      disabled={isLoading}
      data-cy="cancel-sync-connection-button"
    />
  ) : (
    <Button
      style="text"
      icon={Redo}
      label="Sync now"
      iconPosition="left"
      onClick={e => {
        e.stopPropagation();
        handleSync(connectionId);
      }}
      loading={isLoading}
      disabled={isLoading}
      data-cy="sync-connection-button"
    />
  );
};

export default Sync;
